import { api } from "../../lib/api";

export interface SafeUser {
  id: string;
  email: string;
  fullName: string | null;
  role: "user" | "admin" | "commercial";
  emailVerified: boolean;
  totpEnabled: boolean;
  createdAt: string;
}

export interface TokenBundle {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  user: SafeUser;
}

export const register = (body: { email: string; password: string; fullName?: string }) =>
  api<{ user: SafeUser }>("/auth/register", { method: "POST", body }).then((r) => r.user);

export const login = (body: { email: string; password: string }) =>
  api<TokenBundle>("/auth/login", { method: "POST", body });

export const fetchMe = () => api<{ user: SafeUser }>("/me");

export const requestPasswordReset = (email: string) =>
  api<{ ok: true }>("/auth/request-password-reset", { method: "POST", body: { email } });

export const logout = () => api<{ ok: true }>("/auth/logout", { method: "POST", body: {} });
